import axios from 'axios';
import { AddressCoordinatesSearchQueryResponse } from '../../../types/models/address/address.types';
import { UseAddressCoordinatesAutocompleteQueryParams } from './useAddressCoordinatesAutocomplete.types';

export const ADDRESS_COORDINATES_AUTOCOMPLETE_QUERY_KEY = 'ADDRESS_COORDINATES_AUTOCOMPLETE';

export const queryAddressCoordinatesAutocomplete = async (
  address: string,
  params?: UseAddressCoordinatesAutocompleteQueryParams
) => {
  const { data } = await axios.get(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(address)}.json`,
    {
      params: {
        autocomplete: true,
        access_token:
          'pk.eyJ1IjoieWFjaW5lbGVucyIsImEiOiJjbGlvYjM2aHQwZTVzM2ZwY2RmbXhydjhxIn0.YVjskQUq6YwvpN2M14iVfg',
        language: 'fr',
        session_token: '06cfdd8d-38cb-4391-8889-a7b674200a1z',
        proximity: 'ip',
        types: ['address', 'place', 'region'],
        ...params
      },
      transformResponse: (response) => {
        const { features } = JSON.parse(response) as AddressCoordinatesSearchQueryResponse;
        return features;
      },
    }
  );

  return data;
};
